export enum Board {
  BeadRoad = 'beadRoad',
  BigRoad = 'bigRoad',
  Trends = 'trends',
}

export const DEFAULT_BOARD_ROWS_COUNT: number = 6;
